import { render, staticRenderFns } from "./WrapPage.vue?vue&type=template&id=3826dd02&scoped=true&"
import script from "./WrapPage.vue?vue&type=script&lang=js&"
export * from "./WrapPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3826dd02",
  null
  
)

export default component.exports